module.exports = __webpack_public_path__ + "static/media/gluten-free.e42848b1.jpg";